import React from 'react';

const ContactUs = () => {
  return(
    <div className="contact-us-wrapper">
      <div className="cu-left">
        <div className="cu-inner-container">
          <i className="fa cu-icon fa-envelope" aria-hidden="true"></i>
          <p>enquiries@vizkidz.co.uk</p>
        </div>
        <div className="cu-inner-container">
          <i className="fa cu-icon fa-facebook-official" aria-hidden="true"></i>
          <p>VizKidzUK</p>
        </div>
      </div>

      <div className="cu-right">
        <div className="cu-inner-container">
          <i className="fa cu-icon fa-phone-square" aria-hidden="true"></i>
          <p>+44(0) 1424 219001</p>
        </div>
        <div className="cu-inner-container">
          <i className="fa cu-icon fa-twitter" aria-hidden="true"></i>
          <p>VizKidzUK</p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;


// WEBPACK FOOTER //
// ./src/components/common/ContactUs.js